import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Typography, IconButton, Paper, InputBase } from '@mui/material';
import { Search, Upload, Add, FilterList, UploadOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { styled } from '@mui/material/styles';
import api from '../../utils/api';
import AllVendor from '../../component/allvendor/AllVendor';
import UserHeader from '../../component/reusable/UserHeader';
import { setSubcategoryRefresh } from '../../redux/subcategories/getAllSubcategorySlice';
import Cards from '../../component/reusable/Cards';
import AllBomOrderTable from '../../component/bomComps/AllBomOrderTable';
import BomOrderCard from '../../component/bomComps/BomOrderCard';
import BomOrderTab from '../../component/bomComps/BomOrderTab';
import { exportDataExcel, fomateDate } from '../../utils/fomateDate';
import { deletebomOrderThunk, exportbomOrderThunk, getAllBomOrderThunk, getbomOrderStatisticsThunk, setbomOrderFromDate, setbomOrderPage, setbomOrderSearch, setbomOrderSelectedTab, setbomOrderToDate } from '../../redux/bomOrderSlice';
import BomOrderFilter from '../../component/bomComps/BomOrderFilter';

const SearchInput = styled(Paper)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
    width: '320px',
    margin: "20px 0px",
    fontFamily: `'Public Sans', sans-serif`,
}));

function BomOrders() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [allStatus, setAllStatus] = useState('')
    const [limit, setLimit] = useState(25)
    const [sortBy, setSortyBy] = useState('createdAt');
    const [order, setOrder] = useState('desc')
     const [selectedId, setSelectedId] = useState(null)
      const [isModalOpen, setIsModalOpen] = useState(false);

       const deleteCategory = (password) => {
          dispatch(deletebomOrderThunk({ id: selectedId, password }))
          setIsModalOpen(false);
      
        }
      
      
        //delete modal open
        const handleDeleteClick = (id) => {
          setIsModalOpen(true);
          setSelectedId(id)
        };

    const handleChange = (event, newValue) => {
        dispatch(setbomOrderSelectedTab(newValue))
        setAllStatus('')
        dispatch(setbomOrderPage(1))
        dispatch(setbomOrderSearch(''))
        dispatch(setbomOrderFromDate(''))
        dispatch(setbomOrderToDate(''))
    };



    const { bom, loading, refresh, page, search, fromDate, toDate, exportLoading, selectedTab, orderStatistics } = useSelector((state) => state.bomOrder);
    const bomData = bom?.data
    const totalPages = bom?.totalPages
    const totalItems = bom?.totalItems
    const itemsPerPage = bom?.limit

    const start = (page - 1) * limit + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * limit + limit;

    const status = selectedTab === 0 ? allStatus : selectedTab === 1 ? 'NEW' : selectedTab === 2 ? 'DELIVERED' : "CANCELLED"

    //    console.log(bom);

    useEffect(() => {
        dispatch(getAllBomOrderThunk(`?search=${search}&page=${page}&status=${status}&fromDate=${fromDate}&toDate=${toDate}&sortBy=${sortBy}&order=${order}&orderType=BOM`));
    }, [page, search, status, limit, refresh, sortBy, order, fromDate, toDate]);

    useEffect(() => {
        dispatch(getbomOrderStatisticsThunk(`?orderType=BOM`))
    }, [])

    const handleOpenMenu = (sort) => {
        setSortyBy(sort)
        setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };

    const exportbomenq = async () => {
        const status = await dispatch(exportbomOrderThunk(`?limit=${100000}&orderType=BOM`))
        if (status?.payload?.success === true) {
            console.log("status", status?.payload?.data);

            const exportOrderData = status?.payload?.data
            const exportdata = exportOrderData?.map((item) => ({
                'id': item?._id || '-',
                'Name': item?.user?.fullName || '-',
                'Company': item?.user?.companyName || '-',

                'products': item?.productCount + 'products',
                'Total': item?.total || '-',
                'Status': item?.status || '-',
                'CreatedAt': fomateDate(item?.createdAt),
            }))
            // console.log("expo", exportdata);

            exportDataExcel(exportdata, "bom")
        }
    }



    return (
        <>
            <UserHeader
                index="BOM Orders"
                root="Dashboard"
                exportData={exportbomenq}
                exportLoading={exportLoading}
                hideadd={'hide'}
            />

            <BomOrderCard
                orderStatistics={orderStatistics}
            />

            <Box>

                <BomOrderTab handleChange={handleChange} selectedTab={selectedTab} />
                <BomOrderFilter
                    setAllStatus={setAllStatus}
                    search={search}
                    selectedTab={selectedTab}
                    setOrderFromDate={setbomOrderFromDate}
                    setOrderToDate={setbomOrderToDate}
                    setSearch={setbomOrderSearch}
                />

                <Box >
                    {
                        loading ?
                            <div style={{ display: 'flex', justifyContent: 'center' }}>Loading...</div>
                            :
                            <>
                                {bomData?.length > 0 ?
                                    <Typography>
                                        <AllBomOrderTable
                                            bomData={bomData}
                                            page={page}
                                            setPage={setbomOrderPage}
                                            itemsPerPage={itemsPerPage}
                                            totalItems={totalItems}
                                            totalPages={totalPages}
                                            start={start}
                                            end={end}
                                            handleOpenMenu={handleOpenMenu}
                                            selectedTab={selectedTab}
                                            handleDeleteClick={handleDeleteClick}
                                            deleteCategory={deleteCategory}
                                            setIsModalOpen={setIsModalOpen}
                                            isModalOpen={isModalOpen}
                                            path={'/bom/BomOrderDetails'}
                                        />
                                    </Typography>
                                    :
                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                        No Data found
                                    </div>
                                }
                            </>
                    }
                </Box>

            </Box>
        </>
    );
}

export default BomOrders;
